import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "../../components/DialogBoxCustom.css";
import useApiPost from "../hooks/postData";
import toast from "react-hot-toast";
import Loader from "../../assets/Loader.gif";

function AssignHashtagDialog({ open, handleClose, onSaved, category }) {
  const { postData: postAssign, loading: assigning } = useApiPost();
  const { postData: postUnassign, loading: unassigning } = useApiPost();

  const [newTag, setNewTag] = useState("");
  const [newEmoji, setNewEmoji] = useState("");

  useEffect(() => {
    if (open) {
      setNewTag("");
      setNewEmoji("");
    }
  }, [open, category]);

  if (!category) return null;

  const hashtags = category.hashtags || [];
  const emojis = category.emojis || {};

  const handleAddTag = async () => {
    const tag = newTag.trim().replace(/^#/, "");
    if (!tag) {
      toast.error("Please enter a hashtag");
      return;
    }

    const payload = {
      category_id: category.id,
      hashtags: [tag],
    };
    if (newEmoji.trim() !== "") {
      payload.emojis = { [tag]: newEmoji.trim() };
    }

    try {
      const response = await postAssign("/hashtag-category/assign", payload);
      if (response?.response_code === "1") {
        toast.success("Hashtag assigned");
        setNewTag("");
        setNewEmoji("");
        onSaved();
      } else {
        toast.error(response?.message || "Failed to assign hashtag");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to assign hashtag");
    }
  };

  const handleRemoveTag = async (tag) => {
    try {
      const response = await postUnassign("/hashtag-category/unassign", {
        hashtags: [tag],
      });
      if (response?.response_code === "1") {
        toast.success("Hashtag removed");
        onSaved();
      } else {
        toast.error(response?.message || "Failed to remove hashtag");
      }
    } catch (err) {
      toast.error("Failed to remove hashtag");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth className="p-0 hashtag-dialog">
      <DialogTitle className="flex justify-center text-base font-bold text-[#000000] font-poppins dark:bg-primary bg-[#FFFFFF] shadow-lg dark:text-darkText">
        Manage Hashtags — {category.name}
      </DialogTitle>

      <button
        onClick={handleClose}
        className="absolute text-2xl text-gray-600 dark:text-white top-2 right-2"
      >
        ×
      </button>

      <DialogContent className="flex flex-col mx-5 dark:mx-0 dark:bg-primary">
        {/* Add new hashtag */}
        <h2 className="text-base font-poppins text-[#000000] pt-4 font-semibold dark:text-darkText">
          Add Hashtag
        </h2>
        <div className="flex gap-2 my-1">
          <input
            type="text"
            placeholder="hashtag (without #)"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            className="border border-opacity-gradient rounded-lg dark:bg-transparent dark:border-[#1F1F1F] placeholder:text-tableDarkLarge dark:text-darkText text-[#000000] flex-1 py-3 px-4 placeholder:text-sm placeholder:text-[#0000004F] bg-white focus:outline-none focus:ring-1 focus:ring-header"
          />
          <input
            type="text"
            placeholder="emoji (optional)"
            value={newEmoji}
            onChange={(e) => setNewEmoji(e.target.value)}
            maxLength={4}
            className="border border-opacity-gradient rounded-lg dark:bg-transparent dark:border-[#1F1F1F] placeholder:text-tableDarkLarge dark:text-darkText text-[#000000] w-24 py-3 px-3 placeholder:text-xs placeholder:text-[#0000004F] bg-white focus:outline-none focus:ring-1 focus:ring-header"
          />
        </div>
        <button
          className="w-full py-3 mt-2 font-medium text-white rounded-xl bg-button-gradient"
          onClick={handleAddTag}
        >
          {assigning ? (
            <div className="flex justify-center py-1">
              <img src={Loader} alt="loader" height={16} width={16} />
            </div>
          ) : (
            "Add to Category"
          )}
        </button>

        {/* Existing hashtags */}
        <h2 className="text-base font-poppins text-[#000000] pt-6 font-semibold dark:text-darkText">
          Assigned Hashtags ({hashtags.length})
        </h2>
        <div className="flex flex-col gap-2 py-2 max-h-[260px] overflow-y-auto">
          {hashtags.length === 0 ? (
            <p className="text-sm font-poppins text-[#858585] dark:text-tableDarkLarge">
              No hashtags assigned yet.
            </p>
          ) : (
            hashtags.map((tag) => (
              <div
                key={tag}
                className="flex items-center justify-between px-3 py-2 bg-[#F2F2F2] dark:bg-[#1F1F1F] rounded-lg"
              >
                <span className="font-poppins text-sm text-[#000000] dark:text-darkText">
                  {emojis[tag] ? `${emojis[tag]} ` : ""}#{tag}
                </span>
                <button
                  onClick={() => handleRemoveTag(tag)}
                  disabled={unassigning}
                  className="px-2 py-1 text-xs text-white bg-red-500 rounded-md"
                >
                  Remove
                </button>
              </div>
            ))
          )}
        </div>

        <div className="py-4" />
      </DialogContent>
    </Dialog>
  );
}

export default AssignHashtagDialog;